import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

import { PhoneSelectionType } from "@/enums/communicationLogs";
import { CommunicationProvider } from "@/enums/communicationProviders";
import { PhoneNumberPreferences } from "@/enums/preferences";

import type { PhoneNumberRoutingValue } from "@/models/preferences";
import type { IUser } from "@/models/users";

export const useTwilio = () => {
  const { getters, dispatch } = useStore();

  const savedPhoneNumber = ref<PhoneNumberRoutingValue | null>(null);
  const preferredDialer = ref<CommunicationProvider | null>(null);

  const twilioAccessToken = computed(() => getters["auth/twilioAccessToken"]);
  const user = computed<IUser | null>(() => getters["auth/user"]);

  const savedPhoneDisplay = computed(() =>
    savedPhoneNumber.value?.type === PhoneSelectionType.Auto
      ? PhoneSelectionType.Auto
      : savedPhoneNumber.value?.phone_number || "-"
  );

  const getSavedPhoneNumber = () => {
    savedPhoneNumber.value =
      (user.value?.preferences?.find(
        ({ key }) => key === PhoneNumberPreferences.routing
      )?.value as PhoneNumberRoutingValue) ?? null;
  };

  const getPreferredDialer = () => {
    preferredDialer.value =
      (user.value?.preferences?.find(
        ({ key }) => key === PhoneNumberPreferences.provider
      )?.value as CommunicationProvider) ?? CommunicationProvider.RingCentral;
  };

  const fetchTwilioToken = () => dispatch("auth/fetchTwilioAccessToken");

  watch(
    () => user.value?.preferences,
    () => {
      getSavedPhoneNumber();
      getPreferredDialer();
    },
    {
      immediate: true,
      deep: true,
    }
  );

  return {
    twilioAccessToken,
    fetchTwilioToken,
    savedPhoneNumber,
    savedPhoneDisplay,
    preferredDialer,
  };
};
